module.exports = __webpack_public_path__ + "media/images/flags/4x3/kwt-584cd93f677cb830c098823a95b21622.svg";